import { Route, Routes } from "react-router-dom";
import CreateAddress from "./create/CreateAddress";
import CreateCustomer from "./create/CreateCustomer";
import { CustomerContextProvider } from "./CustomerContext";
import CustomerDetail from "./detail/CustomerDetail";
import CustomerSearch from "./search/CustomerSearch";
import UpdateAddress from "./update/UpdateAddress";
import UpdateCustomer from "./update/UpdateCustomer";
import CustomerInfo from "./detail/CustomerInfo";

export function Customers()
{
    return (
        <>
            <Routes>
                <Route path="/" element={<CustomerContextProvider><CustomerSearch/></CustomerContextProvider>}/>
                <Route path="/create" element={<CustomerContextProvider><CreateCustomer/></CustomerContextProvider>}/>
                <Route path="/:customerId/*" element={<CustomerContextProvider><CustomerDetail/></CustomerContextProvider>}>
                    <Route path="" element={<CustomerInfo/>} />
                    <Route path="address/create" element={<CreateAddress/>}/>
                    <Route path="address/:addressId/update" element={<UpdateAddress/>}/>
                    <Route path="update" element={<UpdateCustomer/>}/>
                </Route>
            </Routes>
        </>
    )
}